import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-reasons',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './reasons.html',
  styleUrl: './reasons.scss',
})
export class Reasons {
  ts = inject(TranslationService);
  t = this.ts.t;

  reasons = computed(() => [
    { num: 1,  title: this.t().r1_title,  desc: this.t().r1_desc  },
    { num: 2,  title: this.t().r2_title,  desc: this.t().r2_desc  },
    { num: 3,  title: this.t().r3_title,  desc: this.t().r3_desc  },
    { num: 4,  title: this.t().r4_title,  desc: this.t().r4_desc  },
    { num: 5,  title: this.t().r5_title,  desc: this.t().r5_desc  },
    { num: 6,  title: this.t().r6_title,  desc: this.t().r6_desc  },
    { num: 7,  title: this.t().r7_title,  desc: this.t().r7_desc  },
    { num: 8,  title: this.t().r8_title,  desc: this.t().r8_desc  },
    { num: 9,  title: this.t().r9_title,  desc: this.t().r9_desc  },
    { num: 10, title: this.t().r10_title, desc: this.t().r10_desc },
  ]);
}
